import { render, staticRenderFns } from "./Screen.vue?vue&type=template&id=6e8a6aff&scoped=true"
import script from "./Screen.vue?vue&type=script&lang=js"
export * from "./Screen.vue?vue&type=script&lang=js"
import style0 from "./Screen.vue?vue&type=style&index=0&id=6e8a6aff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8a6aff",
  null
  
)

export default component.exports